import type { ReactNode } from "react";
import { GridListItem, type GridListItemProps } from "react-aria-components";

interface ReorderableListItemProps extends GridListItemProps {
  id: string;
  children: ReactNode;
  className?: string;
}

export function ReorderableListItem({ id, children, ...props }: ReorderableListItemProps) {
  return (
    <GridListItem id={id} {...props}>
      {children}
    </GridListItem>
  );
}
